import React, { useEffect, useState } from 'react';
import { getAllPrograms } from '../../services/ProgramsService';
import ProgramCard from '../../components/ProgramCard';
import './styles.css';

export default function ProgramsPage() {
  const [programs, setPrograms] = useState([]);

  useEffect(() => {
    async function load() {
      const result = await getAllPrograms();
      setPrograms(result);
    }
    load();
  }, []);

  return (
    <div className="programs-hero-section">
      <div className="programs-content-wrapper">
        <h1 className="programs-title">Explore Our Partner Programs</h1>
        <p className="programs-subtext">
          These curriculum tracks are designed to guide high school mentors and elementary students through engaging STEAM challenges.
        </p>
        <div className="program-cards-container">
          {programs.map((program) => (
            <ProgramCard key={program.id} program={program} />
          ))}
        </div>
      </div>
    </div>
  );
}
